import { createAction } from '@reduxjs/toolkit';
import { showHideLoader } from './loader';
import { accountListSuccess } from './account';
import {
  INCORRECT_AUTH_CODE_MULTIPLE_RETRY_ERROR,
  INCORRECT_AUTH_CODE_ERROR,
  ACCOUNT_SERVICE_TANDC_ERROR
} from 'constants/errorCode';
import { ACCOUNT_SERVICE_TANDC_MESSAGE } from 'constants/general';

export const responseFailed = createAction('error/responseFailed', function prepare(param) {
  return {
    payload: param || { error: {} }
  };
});

export const authCodeFailed = (failedResponse) => (dispatch) => {
  //fail response is coming in below format from apiUrlmiddleware
  const {
    originalError: {
      response: { data }
    }
  } = failedResponse.error;
  if (
    data &&
    data.error &&
    (data.error.code === INCORRECT_AUTH_CODE_MULTIPLE_RETRY_ERROR ||
      data.error.code === INCORRECT_AUTH_CODE_ERROR)
  ) {
    dispatch(authCodeFailureResponse(data));
    dispatch(showHideLoader(false));
  } else dispatch(responseFailed(data));
};
export const authCodeFailureResponse = createAction(
  'case/authCodeFailureResponse',
  function prepare(response) {
    return {
      payload: response
    };
  }
);
export const bankDetailsFailed = (response) => (dispatch) => {
  const {
    originalError: {
      response: { data }
    }
  } = response.error;
  dispatch(bankDetailsFailureResponse(data));
  dispatch(showHideLoader(false));
};
export const bankDetailsFailureResponse = createAction(
  'case/bankDetailsFailureResponse',
  function prepare(response) {
    return {
      payload: response
    };
  }
);
export const accountServiceFailed = (failedResponse, param) => (dispatch) => {
  const {
    originalError: {
      response: { data, headers }
    }
  } = failedResponse.error;
  //handled the 401 error and send empty accounts so that customer can enter his bank details.
  if (
    data &&
    data.status &&
    data.status.toString() === ACCOUNT_SERVICE_TANDC_ERROR &&
    headers['www-authenticate'] === ACCOUNT_SERVICE_TANDC_MESSAGE
  ) {
    const response = { accounts: [] };
    dispatch(accountListSuccess(response, param.showLoader));
  } else dispatch(responseFailed(data));
};
